module.exports = __webpack_public_path__ + "static/media/computer-sm.22bab8c4.png";